
import React, { useState } from "react";
import sad from "../../../assets/images/NewActivityImages/sad.jpg";
import happy from "../../../assets/images/NewActivityImages/happy.jpg";
import bird from "../../../assets/images/NewActivityImages/bird.jpg";


export default function BubbleSortQuiz() {
  const correct = {
    1: "b",
    2: "b",
    3: "a",
    4: "b",
    5: "a",
    6: "a",
    7: "a",
    8: "a",
    9: "a",
    10: "a",
  };

  const [current, setCurrent] = useState(1);
  const [results, setResults] = useState({});
  
  const [character, setCharacter] = useState(
    bird
  );

  const questions = [
    { q: "What does Bubble Sort do?", opts: ["Adds new numbers", "Sorts numbers in order", "Deletes numbers"] },
    { q: "What happens when two numbers are in the wrong order?", opts: ["They stay the same", "They swap places", "They disappear"] },
    { q: "Which number moves to the end after each round?", opts: ["The biggest number", "The smallest number", "A random number"] },
    { q: "Bubble Sort compares...", opts: ["Every pair at once", "Two numbers at a time", "Only the first number"] },
    { q: "What does 'swap' mean?", opts: ["To exchange places", "To remove both", "To color them"] },
    { q: "How do we know sorting is done?", opts: ["When no swaps are needed", "When list disappears", "When numbers are random"] },
    { q: "Bubble Sort is an example of...", opts: ["Sorting Algorithm", "Searching Algorithm", "Drawing Algorithm"] },
    { q: "What is the first step in Bubble Sort?", opts: ["Compare first two numbers", "Swap all numbers randomly", "Delete last number"] },
    { q: "Bubble Sort repeats steps until...", opts: ["All numbers are sorted", "Only first number is sorted", "Numbers are deleted"] },
    { q: "Bubble Sort is also called...", opts: ["Exchange Sort", "Quick Sort", "Linear Sort"] },
  ];

  const handleAnswer = (qIndex, ans) => {
    if (ans === correct[qIndex + 1]) {
      setResults((prev) => ({ ...prev, [qIndex + 1]: "✅ Correct!" }));
      setCharacter(happy);
      setTimeout(() => {
        setCurrent((prev) => prev + 1);
        setCharacter(bird)
      }, 1200);
    } else {
      setResults((prev) => ({ ...prev, [qIndex + 1]: "❌ Try again!" }));
      setCharacter(sad);
    }
  };

  return (
    <div
      style={{
        fontFamily: "'Comic Neue', cursive",
        background: "linear-gradient(135deg,rgb(255, 255, 255), #ffffff)",
        textAlign: "center",
        color: "#333",
        padding: "30px",
        overflowX: "hidden",
        position: "relative",
        minHeight: "100vh",
      }}
    >
      <h1
        style={{
          color: "#ff6f61",
          textShadow: "2px 2px #fff",
          fontSize: "2.5em",
        }}
      >
        Bubble Sort Adventure Quiz!
      </h1>
      <p>Answer one question at a time to move forward in the Bubble Sort journey!</p>

      <img
        src={character}
        alt="Cartoon"
        style={{
          position: "fixed",
          bottom: "10px",
          left: "10px",
          width: "120px",
          transition: "all 0.5s ease",
        }}
      />

      {questions.map((q, i) =>
        current === i + 1 ? (
          <div
            key={i}
            style={{
              background:  "linear-gradient(135deg,rgb(126, 153, 230),rgb(142, 181, 231))",
              margin: "20px auto",
              padding: "25px",
              borderRadius: "20px",
              width: "80%",
              boxShadow: "0 6px 25px rgba(0,0,0,0.15)",
            }}
          >
            <h3>
              {i + 1}️⃣ {q.q}
            </h3>
            {q.opts.map((opt, idx) => (
              <button
                key={idx}
                style={{
                  background: "linear-gradient(45deg, #f6d365, #fda085)",
                  color: "#fff",
                  border: "none",
                  borderRadius: "12px",
                  padding: "12px 25px",
                  cursor: "pointer",
                  margin: "8px",
                  fontSize: "1em",
                }}
                onClick={() => handleAnswer(i, String.fromCharCode(97 + idx))}
              >
                {String.fromCharCode(65 + idx)}. {opt}
              </button>
            ))}
            <div
              style={{
                fontWeight: "bold",
                marginTop: "15px",
                fontSize: "1.2em",
                color: results[i + 1]?.includes("✅") ? "green" : "red",
              }}
            >
              {results[i + 1]}
            </div>
          </div>
        ) : null
      )}

      {current > questions.length && (
        <h2 style={{ color: "#00897b" }}>
          🎉 Amazing! You finished the Bubble Sort Quiz!
        </h2>
      )}
    </div>
  );
}
